import "./styles.scss";

import Button from "components/ui/button";
import Dialog from "components/ui/dialog";
import { BaIconTrash } from "components/ui/icons";
import { useApp, useQueryDict } from "hooks/app";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { bdayFetch } from "services/utils";

import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";

const CardSendDelete = ({ cardSend, onClose, onSuccess, variant = "button", ...rest }) => {
  const { queryDict } = useQueryDict();
  const [deletePopupOpen, setDeletePopupOpen] = useState(false);
  const { showAlert } = useApp();

  const hasGiftCards = !!cardSend.giftCards && cardSend.giftCards.length > 0;

  const onDeleteClick = () => {
    setDeletePopupOpen(true);
  };

  const onDeleteCard = async () => {
    const { errors } = await bdayFetch("/api/1/card/send/delete", { method: "POST", body: { ...queryDict, cardSendId: cardSend.cardSendId } });
    if (errors?.length > 0) {
      showAlert({ message: errors[0].errorMessage, type: "error" });
    } else {
      showAlert({ message: "Success! Card has been deleted." });
      onSuccess && onSuccess();
    }
    setDeletePopupOpen(false);
    onClose && onClose();
  };

  const onClosePopup = () => {
    setDeletePopupOpen(false);
    onClose && onClose();
  };

  return (
    <>
      {variant === "button" && (
        <Button onClick={onDeleteClick} {...rest}>
          Delete
        </Button>
      )}
      {variant === "menu-item" && (
        <MenuItem onClick={onDeleteClick} {...rest}>
          <ListItemIcon className="trash">
            <BaIconTrash />
          </ListItemIcon>
          <ListItemText>Delete Card</ListItemText>
        </MenuItem>
      )}
      <Dialog
        open={deletePopupOpen}
        title={hasGiftCards ? "This card has a gift card" : "Are you sure?"}
        subtitle={hasGiftCards ? "Cards with gift cards cannot be deleted." : "You are about to delete the card"}
        onClose={onClosePopup}
        className="card-send-delete-popup"
      >
        <div>
          {!hasGiftCards ? (
            <Button color="red" onClick={onDeleteCard} sx={{ marginBottom: "2rem" }}>
              CONFIRM
            </Button>
          ) : (
            <Button onClick={onClosePopup} sx={{ marginBottom: "2rem" }}>
              GOT IT
            </Button>
          )}
        </div>
      </Dialog>
    </>
  );
};

CardSendDelete.propTypes = {
  cardSend: PropTypes.object.isRequired,
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
  variant: PropTypes.string,
};

export default CardSendDelete;
